module.exports = __webpack_public_path__ + "static/assets/af7d9322f48cca54c360f2dbc4881917.svg";